/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export enum CognitoUserPoolType {
    PORTAL_USER_POOL = 'PORTAL_USER_POOL',
    INTERNAL_USER_POOL = 'INTERNAL_USER_POOL',
}
